import * as types from './types';

export const changeSuppliersVersion = () => ({
  type: types.CHANGE_SUPPLIERS_VERSION
});
